import { PaymentsTerminalController } from '@frontend/payments-terminal-controller';
import TerminalIconP400 from '../collect-payment-multi/assets/terminal-icon-p400-new.png';
import TerminalIconWisePOSE from '../collect-payment-multi/assets/terminal-icon-wisepose.jpg';

type ReaderInfo = Awaited<ReturnType<typeof PaymentsTerminalController.discoverReaders>>[number];

type DeviceTypes = ReaderInfo['deviceType'] | 'justifi';

export function getTerminalImage(deviceType: DeviceTypes) {
  if (deviceType === 'justifi') {
    console.warn('TODO: add justifi terminal image');
  }
  return deviceType === 'bbpos_wisepos_e' ? TerminalIconWisePOSE : TerminalIconP400;
}
